import { BaseService } from './base.service';

export default class NotificationsService extends BaseService {
  public async getNotifications() {
    return this.axios.get(`${this.backendUrl}/app-notifications`);
  }
}
